export const basictableheader =["#","First Name","Last Name","Username","Role","Country"]

export const basictablebody=[
        {
            "num":"1",
            "name":"Alexander",
            "lname":"Orton",
            "username":"@mdorton",
            "role":"Admin",
            "country":"USA"
        },
        {
            "num":"2",
            "name":"John Deo",
            "lname":"Deo",
            "username":"@johndeo",
            "role":"User",
            "country":"USA"
        },
        {
            "num":"3",
            "name":"Randy Orton",
            "lname":"the Bird",
            "username":"@twitter",
            "role":"admin",
            "country":"UK"
        },
        {
            "num":"4",
            "name":"Randy Mark",
            "lname":"Ottandy",
            "username":"@mdothe",
            "role":"user",
            "country":"AUS"
        },
        {
            "num":"5",
            "name":"Ram Jacob",
            "lname":"Thornton",
            "username":"@twitter",
            "role":"admin",
            "country":"IND"
        }
]

export const contextualtableheader = [
   "Class","Heading","Heading"
]
export const contextualtablebody=[
    {
        "class":"primary",
        "title":"Primary",
        "header":"Cell",
        "header2":"Cell"
    },
    {
        "class":"secondary",
        "title":"Secondary",
        "header":"Cell",
        "header2":"Cell"
    },
    {
        "class":"success",
        "title":"Success",
        "header":"Cell",
        "header2":"Cell"
    },
    {
        "class":"info",
        "title":"Info",
        "header":"Cell",
        "header2":"Cell"
    },
    {
        "class":"warning",
        "title":"Warning",
        "header":"Cell",
        "header2":"Cell"
    },
    {
        "class":"danger",
        "title":"Danger",
        "header":"Cell",
        "header2":"Cell"
    },
    {
        "class":"light",
        "title":"Light",
        "header":"Cell",
        "header2":"Cell"
    },
    {
        "class":"active",
        "title":"Active",
        "header":"Cell",
        "header2":"Cell"
    }
]

export const textorbackgroundheader = [
    "#","Heading","Heading"
]

export const textorbackgroundbody = [
    {
        class:"table-active",
        num:"1",
        header:"primary",
        header2:"primary"
    },
    {
        class:"table-active",
        num:"2",
        header:"secondary",
        header2:"secondary"
    },
    {
        num:"3",
        header:"success",
        header2:"success"
    },
    {
        num:"4",
        header:"info",
        header2:"info"
    },
    {
        num:"5",
        header:"warning",
        header2:"warning"
    },
    {
        num:"6",
        header:"danger",
        header2:"danger"
    },
    {
        class:"table-active",
        num:"7",
        header:"light",
        header2:"light"
    }
]

export const tableheader=[
    "#","First Name","Last Name","Username"
]

export const tableoptionsbody = [
    {
        "num":"1",
        "name":"Mark",
        "lname":"Otto",
        "username":"@mdo"
    },
    {
        "num":"2",
        "name":"Jacob",
        "lname":"Thornton",
        "username":"@fat"
    },
    {
        "num":"3",
        "name":"Larry",
        "lname":"the Bird",
        "username":"@twitter"
    }
]

export const responsivetableheader = [
    "#","Table heading","Table heading","Table heading","Table heading","Table heading","Table heading","Table heading","Table heading","Table heading","Table heading","Table heading","Table heading","Table heading","Table heading"
]


export const responsivetablebody = [
    {
        num:"1",
        header:"Table cell",
        header2:"Table cell",
        header3:"Table cell",
        header4:"Table cell",
        header5:"Table cell",
        header6:"Table cell",
        header7:"Table cell",
        header8:"Table cell",
        header9:"Table cell",
        header10:"Table cell",
        header11:"Table cell",
        header12:"Table cell",
        header13:"Table cell",
        header14:"Table cell",
    },
    {
        num:"2",
        header:"Table cell",
        header2:"Table cell",
        header3:"Table cell",
        header4:"Table cell",
        header5:"Table cell",
        header6:"Table cell",
        header7:"Table cell",
        header8:"Table cell",
        header9:"Table cell",
        header10:"Table cell",
        header11:"Table cell",
        header12:"Table cell",
        header13:"Table cell",
        header14:"Table cell",
    },
    {
        num:"3",
        header:"Table cell",
        header2:"Table cell",
        header3:"Table cell",
        header4:"Table cell",
        header5:"Table cell",
        header6:"Table cell",
        header7:"Table cell",
        header8:"Table cell",
        header9:"Table cell",
        header10:"Table cell",
        header11:"Table cell",
        header12:"Table cell",
        header13:"Table cell",
        header14:"Table cell",
    }
]

export const breckpointheader = [
    "#","Table heading","Table heading","Table heading","Table heading","Table heading"
]

export const breckpointbody = [
    {
        num:"1",
        header:"Table cell",
        header2:"Table cell",
        header3:"Table cell",
        header4:"Table cell",
        header5:"Table cell",
    },
    {
        num:"2",
        header:"Table cell",
        header2:"Table cell",
        header3:"Table cell",
        header4:"Table cell",
        header5:"Table cell",
    },
    {
        num:"3",
        header:"Table cell",
        header2:"Table cell",
        header3:"Table cell",
        header4:"Table cell",
        header5:"Table cell",
    }
]

export const borderbottombody = [
    {
        "class":"secondary",
        "num":"3",
        "name":"Jacob",
        "lname":"Thornton",
        "username":"@fat"
    },
    {
        "class":"success",
        "num":"3",
        "name":"Jacob",
        "lname":"Thornton",
        "username":"@fat"
    },
    {
        "class":"info",
        "num":"3",
        "name":"Jacob",
        "lname":"Thornton",
        "username":"@fat"
    },
    {
        "class":"warning",
        "num":"3",
        "name":"Jacob",
        "lname":"Thornton",
        "username":"@fat"
    },
    {
        "class":"danger",
        "num":"3",
        "name":"Jacob",
        "lname":"Thornton",
        "username":"@fat"
    },
    {
        "num":"3",
        "name":"Jacob",
        "lname":"Thornton",
        "username":"@fat"
    }
    
]

export const customtablebody = [
    {
        "num":"1",
        "name":"Mark",
        "lname":"Otto",
        "username":"@mdo"
    },
    {
        "num":"2",
        "name":"Jacob",
        "lname":"Thornton",
        "username":"@fat"
    },
    {
        "num":"3",
        "name":"Larry",
        "lname":"the Bird",
        "username":"@twitter"
    },
    {
        "num":"4",
        "name":"Mark",
        "lname":"Otto",
        "username":"@mdo"
    },
    {
        "num":"5",
        "name":"Jacob",
        "lname":"Thornton",
        "username":"@fat"
    },
]